<template>
  <v-card>
    <v-card-title>
      <span class="headline"> {{ $t("Process payment for") }}...</span>

      <!-- Añadir radio button mesa / usuario y dropdown que coja uno u otro -->
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  data() {}
};
</script>

<style></style>
